<div class="execution-summary">
  <h2 mat-dialog-title>Process Execution Summary</h2>

  <mat-tab-group>
    <mat-tab *ngFor="let status of getStatuses()">
      <ng-template mat-tab-label>
        <span *ngIf="status">
          <status status="{{status}}"></status>
        </span>
      </ng-template>

      <!-- Accordion for sections -->
      <mat-accordion>
        <mat-expansion-panel *ngFor="let type of getTypes(status)">
          <mat-expansion-panel-header>
            <mat-panel-title>
              {{ typeMapping[type] }}
            </mat-panel-title>
          </mat-expansion-panel-header>

          <table>
            <thead>
            <tr>
              <td>Key</td>
              <td>Count</td>
              <td>Amount</td>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let groups of statusGroupings[status][type]">
              <td>{{groups.key}}</td>
              <td>{{groups.count}}</td>
              <td>{{groups.amount | currency: groups.currency}}</td>
            </tr>
            </tbody>
          </table>
        </mat-expansion-panel>
      </mat-accordion>
    </mat-tab>
  </mat-tab-group>

  <!-- Action Buttons -->
  <div mat-dialog-actions class="action-buttons">
    <button mat-button (click)="onCloseClick()">Close</button>
  </div>
</div>
